/**
 * MarketPlace Slice
 */
import { createSlice } from '@reduxjs/toolkit';

export const marketPlaceSlice = createSlice({
    name: 'marketPlace',
    initialState: {
        shoppingCart: [],
    },
    reducers: {
        updateShoppingCart: (state, action) => {
            state.shoppingCart = action.payload;
        },
    },
});

export const { updateShoppingCart } = marketPlaceSlice.actions;
export default marketPlaceSlice.reducer;
